import {
  getPrimaryColor,
  isMobileAtom,
  TermInformationTooltip,
  useRecoil,
} from '@orcar/common-d2c';
import styled, { css } from 'styled-components';
import { app } from '@/constants/common';
import {
  getCurrentInsuranceRange,
  getLockInsuranceRange,
  getTooltipInfo,
} from '@/utils/insurance';

type TableStyledType = {
  isCenter?: boolean;
};

interface TableColumnStyledType extends TableStyledType {
  isTitle?: boolean;
  isSelected?: boolean;
  isMobile?: boolean;
  isBottom?: boolean;
}

type TableRowForSingleTableProps = {
  children: string;
  insuranceType?: string;
  hasTooltip?: boolean;
  value?: string;
  isFullCoverage?: boolean;
  isBottom?: boolean; // 가장 마지막 행의 border-bottom 스타일 적용을 위한 props
  companyName?: string;
};

const TableRowForSingleTable = ({
  children,
  insuranceType,
  hasTooltip,
  value,
  isFullCoverage,
  isBottom,
}: TableRowForSingleTableProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <TableRow isMobile={isMobile}>
      <Td isTitle isMobile={isMobile}>
        {hasTooltip ? (
          <TextWithTooltip>
            {children}
            <TermInformationTooltip value={children}>
              <span>
                <b>{children}</b>
                <br />
                {getTooltipInfo(children, insuranceType)}
              </span>
            </TermInformationTooltip>
          </TextWithTooltip>
        ) : (
          children
        )}
      </Td>
      <Td isSelected isMobile={isMobile} isBottom={isBottom}>
        {isFullCoverage
          ? getLockInsuranceRange(children, insuranceType, value)
          : getCurrentInsuranceRange(children, insuranceType, value)}
      </Td>
    </TableRow>
  );
};

export default TableRowForSingleTable;

const tableBorderStyle = css<TableStyledType>`
  border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
`;

const TableRow = styled.tr<Pick<TableColumnStyledType, 'isMobile'>>`
  height: ${({ isMobile }) => (isMobile ? '40px' : '50px')};
`;

const TextWithTooltip = styled.div<{ renewal?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Td = styled.td<TableColumnStyledType>`
  padding: ${({ isMobile }) => (isMobile ? '8px 0 8px 8px' : '8px 20px')};
  background-color: ${({ isTitle, theme }) => isTitle && theme.COLOR.GREY_BG};

  font-size: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
  font-weight: ${({ isTitle }) => (isTitle ? '600' : '400')};
  color: ${({ isSelected, theme }) =>
    isSelected ? getPrimaryColor(app) : theme.COLOR.GREY_01};
  ${tableBorderStyle};
  white-space: pre-wrap;
`;
